<script setup lang="ts">
defineProps({
    sublineConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            return typeof rawValue?.title === 'string'
        }
    }
})
</script>

<template>
    <div class="subline" v-html="sublineConfig?.title" />
</template>

<style  lang="scss">
.subline {
    @include subline;
}
</style>
